import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { FormDialog } from "@/components/FormDialog";
import { todayStr } from "@/lib/api";

/** columns: [{key,label,render?,align?,className?}] */
export function DataTable({ columns, rows, onRowClick, empty = "Kayıt bulunamadı", testIdPrefix = "row" }) {
  return (
    <div className="overflow-x-auto -mx-1">
      <Table>
        <TableHeader>
          <TableRow>
            {columns.map((c) => (
              <TableHead key={c.key} className={`${c.align === "right" ? "text-right" : ""} whitespace-nowrap`}>{c.label}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.length === 0 && (
            <TableRow><TableCell colSpan={columns.length} className="text-center text-muted-foreground py-10">{empty}</TableCell></TableRow>
          )}
          {rows.map((r) => (
            <TableRow key={r.id} onClick={onRowClick ? () => onRowClick(r) : undefined}
              className={onRowClick ? "cursor-pointer data-row" : "data-row"} data-testid={`${testIdPrefix}-${r.id}`}>
              {columns.map((c) => (
                <TableCell key={c.key} className={`${c.align === "right" ? "text-right tabular-nums" : ""} ${c.className || ""}`}>
                  {c.render ? c.render(r) : r[c.key] ?? "-"}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export function PayDialog({ tx, remaining, label = "Ödeme Gir", onDone, size = "sm", disabled }) {
  const isIncome = tx.direction === "Gelir";
  return (
    <span onClick={(e) => e.stopPropagation()}>
      <FormDialog
        title={isIncome ? "Tahsilat Kaydı" : "Ödeme Kaydı"} triggerLabel={label} triggerVariant="outline" triggerSize={size}
        icon={false} triggerTestId={`pay-${tx.id}`} url="/payments" confirmKey="confirm_overpay" disabled={disabled}
        successMsg={isIncome ? "Tahsilat kaydedildi" : "Ödeme kaydedildi"} onDone={onDone}
        initial={{ transaction_id: tx.id, amount: remaining, payment_date: todayStr(), payment_method: "Havale", status: "Ödendi" }}
        fields={[
          { name: "amount", label: "Tutar (₺)", type: "number", required: true },
          { name: "status", label: "Durum", type: "select", options: ["Ödendi", "Bekliyor"] },
          { name: "payment_date", label: "Ödeme Tarihi", type: "date" },
          { name: "due_date", label: "Vade (planlanan için)", type: "date" },
          { name: "payment_method", label: "Yöntem", type: "select", options: ["Havale", "Nakit", "Kredi Kartı", "Çek", "Senet"] },
          { name: "notes", label: "Not" },
        ]}
      />
    </span>
  );
}
